import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function SettingOutline({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <g transform="translate(2 2)">
                <path d="M8.00002 10H12" stroke={color} strokeWidth="2" strokeLinecap="round"/>
                <path d="M17.1367 3.943L19 7.057L16.9224 9.118V10.882L19 12.943L17.1367 16.057L14.2485 15.355C13.764 15.706 13.2423 16.012 12.6739 16.237L11.8751 19H8.13667L7.32611 16.237C6.75779 16.012 6.23605 15.715 5.75158 15.355L2.86338 16.057L1.00002 12.943L3.07766 10.882V9.118L1.00002 7.057L2.86338 3.943L5.75158 4.645C6.23605 4.294 6.75779 3.988 7.32611 3.763L8.13667 1H11.8634L12.6739 3.763C13.2423 3.988 13.764 4.285 14.2485 4.645L17.1367 3.943Z"
                    stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </g>
        </svg>
    );
}

export default SettingOutline;
